import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { People } from '../interfaces/interfaces.index';

const URL = `${URL_SERVICIOS}People`;
@Injectable({
  providedIn: 'root'
})
export class PersonaService {

  constructor(public http: HttpClient) { }

  getPeopleByUser = (userId: number) => this.http.get<People>(`${URL}/user/${userId}`, HTTP_OPTIONS);

}
